import { render, staticRenderFns } from "./ServiceHandoverPage.vue?vue&type=template&id=6affec64"
import script from "./ServiceHandoverPage.vue?vue&type=script&lang=js"
export * from "./ServiceHandoverPage.vue?vue&type=script&lang=js"
import style0 from "./ServiceHandoverPage.vue?vue&type=style&index=0&id=6affec64&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports